// Status-specific copy for failed API calls. 429 is the common one: the WAF/edge throttles
// benign actions (wishlist add) and users otherwise get a generic "something broke" message.
const MESSAGES_BY_STATUS = {
  401: 'Please sign in to continue.',
  403: 'Please sign in to continue.',
  429: 'Too many requests. Please try again in a moment.',
}

const DEFAULT_MESSAGE = 'Something went wrong. Please try again.'

// Axios puts the status on `error.response`; the legacy window.fetchJSON/postJSON helpers
// attach it directly as `error.status`.
export function httpStatusFromError(error) {
  return error?.response?.status || error?.status || null
}

export function httpErrorMessage(error, fallback = DEFAULT_MESSAGE) {
  return MESSAGES_BY_STATUS[httpStatusFromError(error)] || fallback
}

export function isSuccessStatus(status) {
  return status >= 200 && status < 300
}

export default httpErrorMessage
